// Static site data sourced from Dr. Anuj Singh's CV
export const PROFILE = {
  name: "Dr. Anuj Singh",
  title: "Surgical Oncologist",
  short_title: "Cancer Surgeon | Surgical Oncology",
  credentials: "MCh (Surgical Oncology), MS (General Surgery), MBBS",
  tagline: "Advanced Cancer Care, with Compassion.",
  description:
    "Consultant Surgical Oncologist trained at Tata Memorial Hospital, Mumbai. Specialist in minimally invasive cancer surgery, peritoneal surface malignancies, and comprehensive multidisciplinary cancer care.",
  experience_years: "10+",
  surgeries: "2,000+",
  hospitals_trained: "Tata Memorial",
  phone: "+919118067218",
  phone_display: "+91 91180 67218",
  whatsapp: "+919118067218",
  whatsapp_display: "+91 91180 67218",
  email: "dranujsingh1@gmail.com",
  photo: "https://customer-assets.emergentagent.com/job_cb075802-3200-4ea1-8e15-867a1fc69219/artifacts/mca2w18r_Drp.png",
  socials: {
    youtube: "https://www.youtube.com/@advancecancercarejaipur",
    instagram: "https://www.instagram.com/dranujsingh_oncology/?hl=en",
    facebook: "https://www.facebook.com/profile.php?id=61580512439286",
    google: "https://share.google/5K6WQTxQvH1CdzWvo",
  },
};

export const CLINICS = [
  {
    id: "sdmh",
    name: "Santokba Durlabhji Memorial Hospital",
    short: "SDMH Hospital",
    address: "Bhawani Singh Road, Rambagh, Jaipur",
    timings: "9:00 AM – 4:00 PM",
    days: "Monday – Saturday",
    map: "https://www.google.com/maps?q=Santokba+Durlabhji+Memorial+Hospital+Bhawani+Singh+Road+Jaipur&output=embed",
    direct: "https://www.google.com/maps/search/?api=1&query=Santokba+Durlabhji+Memorial+Hospital+Jaipur",
  },
  {
    id: "vaani",
    name: "Vaani Multispeciality Clinic",
    short: "Vaani Clinic",
    address: "Gandhi Path West, Maa Hinglaj Nagar, Lalarpura, Jaipur",
    timings: "6:00 PM – 8:00 PM",
    days: "Monday – Saturday",
    map: "https://www.google.com/maps?q=Gandhi+Path+West+Maa+Hinglaj+Nagar+Lalarpura+Jaipur&output=embed",
    direct: "https://www.google.com/maps/search/?api=1&query=Gandhi+Path+West+Lalarpura+Jaipur",
  },
];

export const SERVICES = [
  {
    title: "Minimally Invasive Oncosurgery",
    desc: "Robotic (Da Vinci & SSI), Laparoscopic and Uniportal VATS — smaller incisions, less pain, faster recovery and equal oncological outcomes.",
    icon: "Microscope",
    span: "lg:col-span-7 lg:row-span-2",
    accent: "emerald",
    badge: "Robotic · Laparoscopic · Uniportal VATS",
  },
  {
    title: "Peritoneal Surface Malignancies",
    desc: "Comprehensive management of peritoneal cancer including CRS with HIPEC and PIPAC.",
    icon: "Activity",
    span: "lg:col-span-5",
    accent: "sky",
    badge: "HIPEC · PIPAC",
  },
  {
    title: "Breast Cancer",
    desc: "Breast conservation, oncoplasty and reconstruction.",
    icon: "Heart",
    span: "lg:col-span-3",
    accent: "emerald",
  },
  {
    title: "GI & Colorectal Cancers",
    desc: "Stomach, liver, pancreas, colon and rectal cancer surgery — laparoscopic & robotic (Da Vinci / SSI).",
    icon: "Stethoscope",
    span: "lg:col-span-3",
    accent: "sky",
  },
  {
    title: "Head & Neck Cancers",
    desc: "Oral, throat, thyroid and salivary gland cancer surgery with reconstruction.",
    icon: "Brain",
    span: "lg:col-span-3",
    accent: "emerald",
  },
  {
    title: "Thoracic & Gynaecologic Oncology",
    desc: "Uniportal VATS lung procedures and complete gynaecologic cancer surgery.",
    icon: "ShieldCheck",
    span: "lg:col-span-3",
    accent: "sky",
  },
];

export const TIMELINE = [
  {
    year: "Present",
    role: "Consultant — Surgical Oncology",
    place: "Santokba Durlabhji Memorial Hospital (SDMH), Jaipur",
  },
  {
    year: "2022 – 2025",
    role: "Associate Professor & Unit Head",
    place: "Department of Surgical Oncology, NIMS Hospital and Research Centre, Jaipur",
  },
  {
    year: "2021 – 2022",
    role: "Assistant Professor",
    place: "Mahamana Pandit Madanmohan Malviya Cancer Centre, Varanasi (Tata Memorial Centre Unit)",
  },
  {
    year: "2020 – 2021",
    role: "Assistant Professor",
    place: "Tata Memorial Hospital, Mumbai",
  },
  {
    year: "2017 – 2020",
    role: "Senior Resident, Surgical Oncology",
    place: "Tata Memorial Hospital, Mumbai",
  },
  {
    year: "2015 – 2017",
    role: "Senior Resident, General Surgery",
    place: "Rama Medical College Hospital, Hapur",
  },
];

export const EDUCATION = [
  {
    year: "2025",
    degree: "Clinical Observership — International Uniportal VATS Training",
    place: "Shanghai Pulmonary Hospital, Tongji University, China",
  },
  {
    year: "2020",
    degree: "MCh Surgical Oncology",
    place: "Tata Memorial Hospital, Mumbai (Homi Bhabha National Institute)",
  },
  {
    year: "2015",
    degree: "MS General Surgery",
    place: "Dr. S. N. Medical College, Jodhpur",
  },
  {
    year: "2011",
    degree: "MBBS",
    place: "S.M.S. Medical College, Jaipur",
  },
];

export const MEMBERSHIPS = [
  "Indian Association of Surgical Oncology (IASO)",
  "International Hepato-Pancreato-Biliary Association (IHPBA)",
  "Indian Society of Peritoneal Surface Malignancies (ISPSM)",
  "Indian Society of Oncology (ISO)",
  "Association of Colon & Rectal Surgeons of India (ACRSI)",
  "Association of Surgeons of India (ASI)",
  "Indian Medical Association (IMA)",
];

export const PUBLICATIONS = [
  {
    title:
      "Efficacy of first-line afatinib in EGFR mutation-positive metastatic non-squamous NSCLC: a prospective cohort single-arm observational study among Indian patients",
    journal: "Journal of Clinical and Diagnostic Research",
    year: "2026",
    detail: "20(5):XC23–XC29",
  },
  {
    title:
      "Perioperative outcomes in locally advanced head and neck cancers reconstructed using free flap: early experience at a tertiary care centre",
    journal: "Indian Journal of Surgical Oncology",
    year: "2026",
  },
  {
    title:
      "Comparison of lymph node yield in en bloc versus level-wise neck dissection in head and neck SCC: a prospective randomized study",
    journal: "Indian Journal of Otolaryngology and Head & Neck Surgery",
    year: "2025",
  },
  {
    title:
      "Basal cell carcinoma in clinical practice: an institutional study from a tertiary care centre",
    journal: "International Journal of Scientific Research",
    year: "2025",
    detail: "14(10):1–4",
  },
  {
    title:
      "Optimizing venous access in cancer care: outcomes of internal jugular vein chemoport insertion",
    journal: "Int J Life Sci Biotechnol Pharma Res",
    year: "2025",
    detail: "14(9):1098–1103",
  },
  {
    title:
      "Use of ChatGPT as an adjunct to multidisciplinary tumour board decision-making for primary head and neck cancer patients",
    journal: "Journal of Medical and Allied Sciences",
    year: "2025",
    detail: "15(2):9",
  },
  {
    title:
      "Definitive role of surgery in management of acromegaly due to ectopic growth hormone secretion: review of literature",
    journal: "International Journal of Research in Medical Sciences",
    year: "2025",
    detail: "13(2):867–870",
  },
  {
    title:
      "Comparison of weekly vs three-weekly cisplatin in concurrent chemoradiotherapy of head and neck cancer: a pilot study",
    journal: "Indian Journal of Otolaryngology and Head & Neck Surgery",
    year: "2024",
  },
  {
    title:
      "Clinical outcomes of pectoralis major myocutaneous flap in head and neck reconstruction: a prospective study",
    journal: "Int J Med Pharm Res",
    year: "2022",
    detail: "3(1):38–42",
  },
  {
    title:
      "Clinical outcomes of capecitabine-based therapies in female patients with metastatic breast cancer",
    journal: "Int J Med Pharm Res",
    year: "2022",
    detail: "3(1):34–37",
  },
  {
    title:
      "Incidence of benign breast disorders presenting to surgery OPD in western Rajasthan: a prospective study of 100 cases",
    journal: "MedPulse International Journal of Surgery",
    year: "2017",
    detail: "3(1):24–28",
  },
  {
    title: "Primary anal malignant melanoma: a case report",
    journal: "International Surgery Journal",
    year: "2015",
    detail: "2:304–307",
  },
  {
    title: "Spontaneous rupture of choledochal cyst during pregnancy: a case report",
    journal: "IOSR Journal of Dental and Medical Sciences",
    year: "2015",
    detail: "14:51–53",
  },
  {
    title: "Inframammary breast with nipple: a rare case report",
    journal: "MedPulse International Journal of Surgery",
    year: "2015",
    detail: "2(1):42–44",
  },
  {
    title:
      "Mandibulotomy — safe and cosmetically best approach for large size sublingual tumours",
    journal: "International Surgery Journal",
    year: "2015",
    detail: "2:421–423",
  },
];

export const TESTIMONIALS = [
  {
    name: "Suresh K.",
    location: "Jaipur",
    relation: "Patient (Colon Cancer)",
    quote:
      "Dr. Anuj explained every step of my surgery with so much patience. The laparoscopic approach meant I was back home in just four days. Forever grateful.",
  },
  {
    name: "Meena Sharma",
    location: "Ajmer",
    relation: "Daughter of patient",
    quote:
      "My mother was treated for breast cancer and the entire team made us feel safe. Dr. Singh's calm reassurance is something we will never forget.",
  },
  {
    name: "Rakesh P.",
    location: "Kota",
    relation: "Patient (Stomach Cancer)",
    quote:
      "We travelled from Kota for a second opinion and decided to stay. His Tata Memorial training shows in every detail of the care plan.",
  },
  {
    name: "Anita V.",
    location: "Jaipur",
    relation: "Patient",
    quote:
      "Genuine, kind and thorough. He answered every question my family had — twice over. That is rare these days.",
  },
];

export const BLOG = [
  {
    title: "10 Early Warning Signs of Cancer You Should Never Ignore",
    excerpt:
      "Most cancers are highly treatable when caught early. Here are the symptoms that warrant a conversation with your doctor.",
    image:
      "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=900&auto=format&fit=crop&q=70",
    tag: "Awareness",
    date: "Nov 2025",
  },
  {
    title: "Minimally Invasive Cancer Surgery: What Patients Should Know",
    excerpt:
      "Smaller incisions, faster recovery and equal oncological outcomes — understanding laparoscopic and VATS surgery.",
    image:
      "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=900&auto=format&fit=crop&q=70",
    tag: "Surgery",
    date: "Oct 2025",
  },
  {
    title: "Life After Cancer: The Survivorship Journey",
    excerpt:
      "Surveillance, nutrition, mental health and getting back to the life you love after cancer treatment.",
    image:
      "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=900&auto=format&fit=crop&q=70",
    tag: "Recovery",
    date: "Sep 2025",
  },
];

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/dxt6abtg_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%282%29.jpeg",
    caption: "International UVATS Certification Ceremony — Shanghai Pulmonary Hospital",
    badge: "Shanghai 2025",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/m2uup9qh_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%281%29.jpeg",
    caption: "International UVATS Training Program — group photo, Shanghai",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/zgfewe10_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%283%29.jpeg",
    caption: "In the OR with international UVATS faculty, Shanghai",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/o8ck0noa_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%2814%29.jpeg",
    caption: "Uniportal VATS — single-port lung cancer surgery",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/fhx0b1ig_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%2813%29.jpeg",
    caption: "Laparoscopic LAR — discharged Day 6",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/cwcgt8ld_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%288%29.jpeg",
    caption: "Post-operative review with patient",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/hfsmwwo7_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%2815%29.jpeg",
    caption: "Laparoscopic LAR — modern era cancer surgery",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/1knejgge_WhatsApp%20Image%202026-05-06%20at%2012.55.31%20PM%20%2810%29.jpeg",
    caption: "Minimally invasive incision — close-up",
  },
];

export const VIDEOS = [
  {
    id: "DZ-oKHwy-gg",
    type: "instagram",
    title: "Featured Instagram Reel",
  },
  {
    id: "eL1KDbsvxTw",
    type: "short",
    title: "Cancer awareness short",
    aspect: "9/16",
  },
  {
    id: "6XX_02oRhRI",
    type: "short",
    title: "Patient education short",
    aspect: "9/16",
  },
  {
    id: "g3Steq1H0ZQ",
    type: "short",
    title: "Surgical technique short",
    aspect: "9/16",
  },
];

export const PRESS = [
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/khbn6ea7_WhatsApp%20Image%202026-05-06%20at%2012.55.32%20PM%20%289%29.jpeg",
    publication: "Samachar Jagat",
    date: "01 February 2026",
    headline: "यूनिपोर्टल वैट्स तकनीक से फेफड़ों के कैंसर की सफल सर्जरी",
    summary:
      "Successful lung cancer surgery using the advanced Uniportal VATS technique at SDMH Hospital, Jaipur — performed by Dr. Anuj Singh and team.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/qy0wsowq_WhatsApp%20Image%202026-05-06%20at%2012.55.32%20PM%20%288%29.jpeg",
    publication: "Punjab Kesari",
    date: "01 February 2026",
    headline: "फेफड़ों के कैंसर की यूनिपोर्टल वैट्स तकनीक से सफल सर्जरी",
    summary:
      "Featured senior surgical oncologist Dr. Anuj Singh — leading a multidisciplinary team for minimally invasive lung cancer surgery at SDMH, Jaipur.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/ueq99u18_WhatsApp%20Image%202026-05-06%20at%2012.55.32%20PM%20%287%29.jpeg",
    publication: "Dainik Jalte Deep",
    date: "February 2026",
    headline: "यूनिपोर्टल वैट्स तकनीक से फेफड़ों के कैंसर की सफल सर्जरी",
    summary:
      "Jaipur now among early centres offering this advanced minimally invasive surgery — bringing world-class cancer care closer to home.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_healthcare-hub-193/artifacts/keh4wbam_WhatsApp%20Image%202026-05-06%20at%2012.55.32%20PM%20%286%29.jpeg",
    publication: "Rajasthan Patrika",
    date: "01 February 2026",
    headline: "फेफड़ों के कैंसर की सफल सर्जरी",
    summary:
      "Coverage of the successful Uniportal VATS lung cancer surgery at SDMH Hospital, Jaipur — performed by Dr. Anuj Singh and team.",
  },
];
